<template>
  <b-dropdown
    ref="menu"
    aria-role="menu"
    v-on:active-change="focusInput($refs.autoInput)">
    <a class="navbar-item"
        slot="trigger"
        role="button">
        <span>{{ title }}</span>
        <b-icon icon="menu-down" pack="mdi"></b-icon>
    </a>
    <b-dropdown-item aria-role="menu-item" custom >
      <b-field :label="label">
          <b-autocomplete
            v-model="selection"
            ref="autoInput"
            placeholder="label"
            icon="label"
            icon-pack="mdi"
            :open-on-focus="true"
            :data="currentOptions"
            @select="selected"
            @typing="getFilteredTags">
            <template slot-scope="props">
              <div class="level">
                <div class="level-left">
                  <span v-if="props.option.count" class="tag level-item">
                    {{ props.option.count }}
                  </span>
                  <span class="level-item">{{ props.option.value }}</span>
                </div>
              </div>
            </template>
          </b-autocomplete>
      </b-field>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'DropDownAutoComplete',
  components: { },
  props: {
    title: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selection: '',
      currentInput: '',
    };
  },
  computed: {
    currentOptions() {
      // Exclude tags that are already selected
      // const tags = _.filter(this.allTags, t => !this.currentTags.includes(t));

      // Filter by any input
      return _.filter(this.options, t => t.value.startsWith(this.currentInput));
    },
  },
  methods: {
    selected(input) {
      if (input) {
        this.$emit('dropdown-selection', { input: input.value });
        this.$refs.menu.toggle();
      }
    },
    sleep(time) {
      return new Promise(resolve => setTimeout(resolve, time));
    },
    focusInput(ref) {
      // This is silly but the click for the pop-up takes focus away from the input
      // So sleep a bit so that the click takes focus then, reset it to the input
      this.sleep(100).then(() => {
        ref.focus();
      });
    },
    getFilteredTags(input) {
      this.currentInput = input;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ input.input {
  width: 20rem;
}

/deep/ .dropdown-menu {
  padding-top: 6px;
}

/deep/ .autocomplete {
  &.dropdown-menu {
    padding-top: 0;
  }
}
</style>
